module.exports = {"AppVersion":"1.0.0","APIBaseUrl":"http://chost22.zim.uni-wuppertal.de/fudapi/api/schwitters/","accesToken":"Bearer fgNbt60U9R7TbbEgqmi55BO4mb8Um1Xb0UpSbUw9"}


//////////////////
// WEBPACK FOOTER
// ./config/config.json
// module id = 930
// module chunks = 1